module.exports = "/_next/static/images/e733accf0d8dd7ac0bb93f6ce62f6935-roxinho-single-md@3x.jpg";